<script lang="ts">
  import { Dialog } from 'bits-ui';
  import { tick } from 'svelte';

  import Markdown from '@/ui/elements/markdown/Markdown.svelte';

  import NotificationButton from './cmps/NotificationButton.svelte';
  import { useNotification } from './use-notification.svelte';

  let [currentNotification, { closeNotification }] = useNotification();

  let notification = $derived(currentNotification?.current);
  let buttonRow = $state<HTMLDivElement | null>(null);

  function onOpenChange(open: boolean) {
    if (!open && notification?.id) {
      closeNotification(notification.id);
    }
  }

  // The dialog focuses its first button. When one button is marked, focus that one instead,
  // after this update has put the buttons in the dialog.
  function onOpenAutoFocus(event: Event) {
    const index = notification?.buttons?.findIndex((button) => button.autofocus) ?? -1;
    if (index < 0) return;
    event.preventDefault();
    void tick().then(() => {
      buttonRow?.querySelectorAll('button')[index]?.focus();
    });
  }
  let cnTextAlign = $derived(notification?.mode === 'info' ? 'text-left' : 'text-center');
</script>

{#if notification}
  <Dialog.Root open {onOpenChange}>
    <Dialog.Overlay class="fixed inset-0 z-50 bg-white/30 backdrop-blur-xs" />
    <Dialog.Content
      preventScroll
      {onOpenAutoFocus}
      class="outline-hidden fc-cc fixed left-1/2 top-1/2 z-50 max-h-[calc(100vh-2rem)] w-[400px] translate-x-[-50%] translate-y-[-50%] gap-6 rounded-lg bg-white px-6 py-8 shadow-card"
    >
      <div class="fc-cc gap-4">
        <p>
          <bold class={['text-md font-semibold', cnTextAlign]}>{notification.title}</bold>
        </p>
        {#if notification.message}
          <Markdown class={cnTextAlign} markdown={notification.message} />
        {/if}
      </div>
      <div class="fr-cc gap-3" bind:this={buttonRow}>
        {#if notification.buttons}
          {#each notification.buttons as button (button.label)}
            <NotificationButton
              label={button.label}
              onclick={button.onclick}
              variant={button.variant}
              notificationId={notification.id}
              disabled={button.disabled}
            />
          {/each}
        {:else}
          <NotificationButton label="OK" notificationId={notification.id} />
        {/if}
      </div>
    </Dialog.Content>
  </Dialog.Root>
{/if}
